module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBoldItalic-4dbd67570f4350707e5403419cfa8206.woff2";